import type { StarterProjectsRouter } from "replo-publisher/src/trpc/routers/starterProjects";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: starterProjectsRouter,
  client: starterProjectsClient,
  utils: starterProjectsUtils,
  options: starterProjectsOptions,
} = createTrpcRouterConfig<StarterProjectsRouter>({
  path: "starterProjects",
  queryClient: getNamespacedQueryClient("starterProjects"),
});

export {
  starterProjectsClient,
  starterProjectsOptions,
  starterProjectsRouter,
  starterProjectsUtils,
};
